import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
    stockTransferDateInput,
    stockTransferDateFilterClear,
    handleStockTransferDateFilter,
} from '../../redux/actions/stock_transfer/stock_transfer.actions';

function StockTransferDateFilter({
    stock_transfer: { date_from },
    stockTransferDateInput,
    stockTransferDateFilterClear,
    handleStockTransferDateFilter,
}) {
    return (
        <Fragment>
            <form onSubmit={handleStockTransferDateFilter}>
                <section className="row mt-1 f-regular">
                    <div className="col-sm-12 col-md-4">
                        <div className="form-group row no-gutters">
                            <label className="col-4 text-center">
                                Date:{' '}
                                <span className="text-danger">*</span>
                            </label>
                            <div className="col-8">
                                <input
                                    type="date"
                                    name="date_from"
                                    value={date_from}
                                    onChange={stockTransferDateInput}
                                    className="form-control"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <div className="btn-group" role="group">
                            <button className="btn btn-primary">
                                Filter
                            </button>
                            <a
                                onClick={stockTransferDateFilterClear}
                                className="btn btn-danger text-white"
                            >
                                <i className="ft ft-spinner"></i> Clear
                            </a>
                        </div>
                    </div>
                </section>
            </form>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    stock_transfer: state.stock_transfer,
});

export default connect(mapStateToProps, {
    stockTransferDateInput,
    stockTransferDateFilterClear,
    handleStockTransferDateFilter,
})(StockTransferDateFilter);
